/* import __COLOCATED_TEMPLATE__ from './send-to-marketo.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();